import React from 'react';
import Link from 'next/link';
import Icons from '../../../public/icons/categoriesIcons';

const ComprehensiveChecks = ({
    title = (
        <>
            Comprehensive Background <br />
            <span className="text-white">Checks We Offer</span>
        </>
    ),
    description = "From standard identity checks to complex due-diligence for senior roles, our platform covers all aspects of verification to ensure you hire the right people.",
    checks = [
        "Identity Verification", "Address Verification",
        "Employment History Verification", "Education Verification",
        "Court & Criminal Record Checks", "Credit & Financial Background Checks",
        "Media & Regulation Checks", "Health & Medical Fitness Checks",
        "Due Diligence for CXO Roles", "Database Driven Global Verification",
        "Custom Verification Packages"
    ],
    btn1Link = "/contact",
    btn1Text = "View Sample Report",
    btn2Link = "/contact",
    btn2Text = "Request Custom Checks",
    showBtn2 = true
}) => {

    return (
        <section className="bg-[#020D1B] py-20 relative overflow-hidden">
            <div className="container-padding-x mx-auto px-4 max-w-6xl">
                <div className="flex flex-col lg:flex-row items-center gap-12">
                    {/* Left Content */}
                    <div className="lg:w-1/2 text-white z-10">
                        <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
                            {title}
                        </h2>
                        <p className="text-gray-400 text-lg mb-8 max-w-lg leading-relaxed">
                            {description}
                        </p>
                        <div className="flex flex-wrap gap-4">
                            <Link href={btn1Link} className="bg-[#168DEF] hover:bg-[#126bbf] text-white px-8 py-3.5 rounded-lg font-medium transition-all shadow-lg hover:shadow-blue-500/20 flex items-center">
                                {btn1Text}
                            </Link>
                            {showBtn2 && (
                                <Link href={btn2Link} className="px-8 py-3.5 rounded-lg font-medium transition-all border border-gray-600 hover:border-gray-400 text-white flex items-center">
                                    {btn2Text}
                                </Link>
                            )}
                        </div>
                    </div>

                    {/* Right Content - Checks Grid */}
                    <div className="lg:w-1/2 w-full z-10">
                        <div className="bg-[#0B1929] border border-gray-800 rounded-2xl p-8 md:p-10 relative">
                            {/* Decorative glow */}
                            <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/5 rounded-full blur-3xl -z-10"></div>

                            <div className="grid md:grid-cols-2 gap-x-8 gap-y-6">
                                {checks.map((check, index) => (
                                    <div key={index} className="flex items-start gap-3">
                                        <div className="mt-1 min-w-[20px]">
                                            <Icons name="verify" />
                                        </div>
                                        <span className="text-gray-300 text-sm md:text-base font-medium leading-tight">
                                            {check}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ComprehensiveChecks;
